import React from "react";

export default function SecurityProtocols() {
  return (
    <>
      <section
        className="clients-section alternat-2 p_30 centred"
        style={{ backgroundColor: "#071522" }}
      >
        <div className="auto-container">
          <div className="inner-container">
            <h2 className="text-white">
              Our Tech Stack and Security Protocols
            </h2>
            <p className="text-white py-4">
              Xeer Technology utilizes leading blockchain platforms, including
              Ethereum, Tezos, and Polkadot, with multi-signature
              authentication, smart contract audits, and end-to-end encryption
              for secure, compliant STOs.
            </p>
          </div>
        
        </div>
      </section>
    </>
  );
}
